import React from 'react';

import InfoTable from 'buyside/components/presentation/IdeaShowPage/InfoTable/infoTable';
import Skeleton, {
  SKELETON_SIZES,
  SKELETON_WIDTHS
} from 'buyside/components/presentation/Skeleton/skeleton';
import Tabs, { TabContent, TabNav } from 'buyside/components/presentation/Tabs/tabsComponents';

import styles from './positionInformationStyles.scss';

const PositionInformationLoading: React.FC = () => {
  return (
    <InfoTable title="Entity Information">
      {({ dataStyle, labelStyle }): React.ReactElement => (
        <>
          <Tabs>
            <TabNav>
              <div>Fundamentals</div>
              <div>Basic Information</div>
              <div>Multiples/Ratios</div>
            </TabNav>
            <TabContent>
              {[1, 2, 3].map(key => (
                <table key={key} className={styles.table}>
                  <tbody>
                    {[1, 2, 3, 4].map(key => (
                      <tr key={key}>
                        <td>
                          <div className={labelStyle}>
                            <Skeleton
                              size={SKELETON_SIZES.SMALL}
                              width={SKELETON_WIDTHS.ONE_THIRD}
                            />
                          </div>
                          <div className={dataStyle}>
                            <Skeleton width={SKELETON_WIDTHS.TWO_THIRD} />
                          </div>
                        </td>
                        <td>
                          <div className={labelStyle}>
                            <Skeleton
                              size={SKELETON_SIZES.SMALL}
                              width={SKELETON_WIDTHS.ONE_THIRD}
                            />
                          </div>
                          <div className={dataStyle}>
                            <Skeleton width={SKELETON_WIDTHS.TWO_THIRD} />
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ))}
            </TabContent>
          </Tabs>
        </>
      )}
    </InfoTable>
  );
};

export default PositionInformationLoading;
